import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { t, useLanguage } from "@/lib/i18n";

export const emptyTutorials = () => [1, 2, 3].map(slot => ({ slot, title: "", video_url: null }));
export const videoUrl = path => `${api.defaults?.baseURL || "/api"}${path}`;
export function VideoBox({ item }) {
  return item.video_url ? <video key={item.video_url} controls playsInline preload="metadata" src={videoUrl(item.video_url)} aria-label={item.title || `${t("Tutorial")} ${item.slot}`} className="w-full aspect-video rounded-lg bg-black object-contain" />
    : <div className="aspect-video rounded-lg bg-amber-50 border border-dashed border-amber-300 flex items-center justify-center text-amber-800">{t("Coming soon")}</div>;
}
export default function HowToVideos({ admin = false }) {
  useLanguage();
  const [items, setItems] = useState(emptyTutorials);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    api.get("/how-to").then(({ data }) => {
      if (active && Array.isArray(data)) setItems(emptyTutorials().map(item => data.find(value => value.slot === item.slot) || item));
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);
  return <section id="how-to" className="py-20 px-5 scroll-mt-20">
    <div className="max-w-7xl mx-auto">
      <h2 className="font-serif text-3xl text-center text-[#2C1E16] mb-3">{t("How to")}</h2>
      <p className="text-center text-stone-600 mb-8">{t("Learn how to explore and preserve your family tree.")}</p>
      {admin && <div className="text-center mb-6"><Link className="text-amber-800 underline" to="/admin/how-to">{t("Manage how-to videos")}</Link></div>}
      {failed && <p role="alert" className="text-center mb-4">{t("Could not load videos. Please reload.")}</p>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">{items.map(item => <article key={item.slot} className="bg-white rounded-xl border border-amber-200 p-4 shadow-sm">
        <h3 className="font-serif text-xl mb-3 break-words">{item.title || `${t("Tutorial")} ${item.slot}`}</h3>
        <VideoBox item={item} />
      </article>)}</div>
    </div>
  </section>;
}
